import classes from "../../classes";
import { connect } from "react-redux";
import DisallowedMessage from "../../components/disallowed-message";
import { getWithdraw, getSession } from "../../selectors";
import { withRouter, Redirect } from "react-router-dom";
import React from "react";
import requireAuthentication from "../../components/higher-order/require-authentication";
import { setWithdrawAmount } from "../../actions/withdraw";
import Steps from "../../components/withdraw/steps";
import WithdrawTransactionSummary from "../../components/withdraw-transaction-summary";

class WithdrawAmountPage extends React.PureComponent {

  constructor(props) {
    super(props);
    this.focusAmount = this.focusAmount.bind(this);
    this.isValid = this.isValid.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setWithdrawAmountFromInput = this.setWithdrawAmountFromInput.bind(this);
  }

  componentDidMount() {
    this.focusAmount();
  }

  focusAmount() {
    this.refs.amount.focus();
  }

  isValid() {
    var { session, withdraw } = this.props;
    var balance = session.get("money_balance");
    var amount = withdraw.get("amount");
    return amount > 0 && amount <= balance;
  }

  onSubmit(e) {
    var { history } = this.props;
    e.preventDefault();
    if (this.isValid()) {
      history.push("/withdraw/method");
    }
  }

  setWithdrawAmountFromInput(e) {
    this.setWithdrawAmountIfNumber(e.target.value);
  }

  setWithdrawAmountIfNumber(amount) {
    var { setWithdrawAmount: onSetWithdrawAmount } = this.props;
    if (amount.length === 0) {
      onSetWithdrawAmount(undefined);
      return;
    }
    var n = parseFloat(amount);
    if (!isNaN(n)) {
      onSetWithdrawAmount(n);
    }
  }

  render() {
    if (!window.env.showAccountPages) {
      return (<Redirect to="/tournaments" />);
    }

    var { session, withdraw } = this.props;

    var canWithdraw = session.get("abilities").contains("make withdrawals");
    if (!canWithdraw) {
      return <DisallowedWithdrawal session={session} />;
    }

    var balance = session.get("money_balance");
    var amount = withdraw.get("amount") || 0.0;
    if (withdraw.get("confirmed")) {
      amount = 0.0;
    }

    return (
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">

          <Steps session={session} withdraw={withdraw} />

          <h1 className="text-center">
            Enter A Withdrawal Amount
          </h1>

          <div className="batch-g batch-g--padding">
            <WithdrawTransactionSummary amount={amount} balance={balance} />

            <div className="batch-c-1-1 batch-c-md-2-3 batch-c-order-md-1">
              <form className="form--is-horizontal" onSubmit={this.onSubmit}>
                <div className="batch-g batch-g--padding batch-g--valign-center">

                  <div className="batch-c-1-1 batch-c-md-1-4">
                    <label htmlFor="amount">
                      Withdrawal Amount
                    </label>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <div className="form_input-prefix" data-prefix="$">
                      <input className="form_input" id="amount" name="amount" onChange={this.setWithdrawAmountFromInput} placeholder="0.00" ref="amount" step="0.01" type="number" />
                    </div>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4" />

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <div className="form_action">
                      <input
                        className={classes({
                          "btn": true,
                          "btn--is-disabled": !this.isValid(),
                          "btn--primary": true
                        })} type="submit" value="Request Withdrawal" />
                    </div>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4" />

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <p className="note-text">
                      Payouts will be received in 7 to 10 business days.
                    </p>

                    <p className="note-text">
                      Please note minimum check withdrawal is $1.00.
                    </p>

                    <p className="note-text">
                      Withdrawals via ACH bank transfer are free.
                    </p>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function DisallowedWithdrawal({ session }) {
  return (
    <div className="l-wrapper">
      <div className="l-content l-content--80-percent">

        <h1 className="text-center">
          Withdrawal
        </h1>

        <DisallowedMessage session={session} />
      </div>
    </div>
  );
}

function select(state) {
  return {
    withdraw: getWithdraw(state),
    session: getSession(state)
  };
}

export default connect(select, { setWithdrawAmount: setWithdrawAmount })(requireAuthentication(withRouter(WithdrawAmountPage)));
